import React from "react";
import {
  formatIndianAmount,
  formatDaysAgo,
  getDisplayPrice,
} from "../Services/Helper";
import { useNavigate } from "react-router-dom";

const FeaturedPropertiesList = (data) => {
    const navigate = useNavigate();
  const defaultImage = "assets/img/property/property-22.jpg";

const imageSrc =
  typeof data?.Images === "string" && data.Images.trim() !== ""
    ? data.Images.split(",")[0].trim()
    : defaultImage;


    const handleNavigate = () => {

      const tabID =
      data?.PropertyTypeID === 1 &&
      data?.VerticalID === 1
        ? 384
        : data?.PropertyTypeID === 1 &&
          data?.VerticalID === 2
        ? 385
        : data?.PropertyTypeID === 1 &&
          data?.VerticalID === 3
        ? 386
        : data?.PropertyTypeID === 2 &&
          data?.VerticalID === 1
        ? 387
        : 388;


          navigate(`/property-details?id=${data?.ListingID}`, {
        state: {
          TabID: tabID,
        },
      });



    }

    


  return (
    <div onClick={()=> handleNavigate()

      } className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
      <div
        className="property-card style4"
        data-aos="fade-up"
        data-aos-duration={1200}
        data-aos-delay={400}
      >
        <div className="property-img">
         <img src={imageSrc} alt="Property" />
          <span className="property-status">
            {" "}
            <i className="ri-heart-fill" />
          </span>
        </div>
        <div className="property-info">
          <h3>
            <a >{data.Title}</a>
          </h3>
          <p>
            <i className="flaticon-location" />
            {data.Locality}
          </p>

          <div className="headss">
            <ul
              className="property-metainfo list-style lst1"
              style={{ marginTop: 10, whiteSpace: "nowrap" }}
            >
              {Array.isArray(data?.UnitFurnishingtitle) &&
                data?.UnitFurnishingtitle?.length > 0 &&
                data?.UnitFurnishingtitle?.slice(0, 3)?.map((title, index) => (
                  <li key={index}>
                    <img
                      src={title?.UnitFurnishingIcon}
                      alt="Furniture"
                      style={{ height: 20, width: 20 }}
                      // className="furnishing-icon"
                    />
                    {title?.Quantity}
                  </li>
                ))}
            </ul>
          </div>
          <p className="property-price">{getDisplayPrice(data)}</p>
        </div>
      </div>
    </div>
  );
};

export default FeaturedPropertiesList;
